module.exports = ".width50{width:400px;margin:2px}.full-width{width:100%}\n"